import React from 'react';
import { Check, X } from 'lucide-react';
import { Container, Reveal } from './shared';

const YES = [
  'du angestellt bist und jeden Monat etwas investieren kannst',
  'du verstehen willst, was du kaufst, statt Tipps hinterherzulaufen',
  'du langfristig ein zweites Einkommen aufbauen willst',
];
const NO = [
  'du heiße Aktientipps suchst, die du einfach nachkaufen kannst',
  'du in vier Wochen reich werden willst',
  'du gerade Konsumschulden abbezahlst, denn die haben Vorrang',
];

const FitCard = ({ title, items, positive, testId }) => (
  <article className="h-full rounded-[24px] border border-line bg-navy p-6 sm:p-8" data-testid={testId}>
    <h3 className="font-display text-2xl font-bold text-white">{title}</h3>
    <ul className="mt-6 space-y-4">
      {items.map((t) => (
        <li key={t} className="flex gap-3 text-[15px] leading-relaxed text-ink sm:text-base">
          <span className={`mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full ${positive ? 'bg-leaf text-brand' : 'bg-nope/10 text-nope'}`}>
            {positive ? <Check size={15} strokeWidth={2.5} aria-hidden="true" /> : <X size={15} strokeWidth={2.5} aria-hidden="true" />}
          </span>
          {t}
        </li>
      ))}
    </ul>
  </article>
);

export const ForWhom = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="forwhom-section">
    <Container className="grid gap-5 md:grid-cols-2">
      <Reveal><FitCard title="Das ist für dich, wenn …" items={YES} positive testId="fit-yes-card" /></Reveal>
      <Reveal delay={100}><FitCard title="… und nichts für dich, wenn …" items={NO} testId="fit-no-card" /></Reveal>
    </Container>
  </section>
);
